export default defineNuxtRouteMiddleware(async (to) => {
  const { $store, $keycloak, $apis, $config } = useNuxtApp()
  if ($keycloak.authenticated) {
    const { host } = new URL(location.href)
    let subdomainPrefix = ''
    if (host !== $config.public.fullyQualifiedDomain) {
      const subDomain = host.split('.')[0]
      // Check if the subdomain is www
      subdomainPrefix = (subDomain === 'www') ? '' : subDomain
      $store.companies.setSubdomain(subdomainPrefix)
    }

    // Redirect
    const { is_superuser, is_zuno_engineer, is_super_typewriter } = $store.auth.authenticatedUser
    const isAdmin = is_zuno_engineer || is_super_typewriter

    if (is_superuser) {
      return navigateTo('/superadmin/home')
    }

    if (isAdmin) {
      return navigateTo('/admin/home')
    }

    // Case: User's company has not been created yet
    if ($store.companies.companies.length === 0 && !isAdmin) {
      // Hacky: This is an insurance policy to really make sure companies indeed doesn't exist
      const companyData = await $apis.companies.fetchAll()
      if (companyData.data.length) {
        $store.companies.setCompanies(companyData.data)
      }
      else {
        return navigateTo('/company/create')
      }
    }

    // Case redirect
    const redirectPath = to.query.redirect as string
    if (redirectPath) {
      return navigateTo(redirectPath)
    }

    return navigateTo('/dashboard/home')
  }
})
